import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

/**
 * Figma (node 122:13):
 * bg-primary (#171717), rounded-md (8px), px-3 (12px), py-1.5 (6px),
 * text-xs (12px), font-normal (400), leading-4 (16px),
 * text-primary-foreground (#fafafa), max-w-[384px], gap-2 (8px)
 */
export interface IntuiTooltipProps {
  content: ReactNode
  children: ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  delayDuration?: number
  className?: string
}

function IntuiTooltip({ content, children, side = 'top', delayDuration = 200, className }: IntuiTooltipProps) {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side={side}
          className={cn(
            'bg-primary text-primary-foreground text-xs font-normal leading-4 rounded-md px-3 py-1.5 max-w-[384px]',
            className
          )}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export { IntuiTooltip }
